  <!-- Header with Topic Display and Menu Toggle -->
  <header class="fixed top-0 left-0 right-0 bg-white shadow-sm z-20">
    <div class="flex items-center justify-between p-4">

      <button class="text-gray-600 hover:text-gray-800 focus:outline-none relative" (click)="onMenuToggle()">
        <span class="material-icons">menu</span>
      </button>
      <h1 class="text-xl font-bold text-gray-800" dir="rtl">הלכות {{ getCurrentTopicName() }}</h1>
      <button class="text-gray-600 hover:text-gray-800 focus:outline-none" (click)="navigateToHome()">
        <span class="material-icons">home</span>
      </button>
    </div>
    <app-menu></app-menu>
  </header>
